module.exports = flarum.core.compat['common/resolvers/DefaultResolver'];